<template>
  <el-card class="box-card full-screen cash-record-statistics">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            :picker-options="pickerOptions0"
            @change="changeDate"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-select
            v-model="queryForm.status"
            :placeholder="$t('all')"
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option :label="$t('checkPending')" value="0"></el-option>
            <el-option :label="$t('getApproved')" value="1"></el-option>
            <el-option :label="$t('notApproved')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('fromBank')" prop="fromBankId">
          <el-select
            size="medium"
            v-model="queryForm.fromBankId"
            filterable
            :placeholder="$t('selectBank')"
            style="width:100%;"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option
              v-for="item in bankList"
              :key="item.id"
              :label="item.bankName"
              :value="item.id"
              v-show="item.status === 0"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('toBank')" prop="toBankId">
          <el-select
            size="medium"
            v-model="queryForm.toBankId"
            filterable
            :placeholder="$t('selectBank')"
            style="width:100%;"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option
              v-for="item in bankList"
              :key="item.id"
              :label="item.bankName"
              :value="item.id"
              v-show="item.status === 0"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="btnStatus.isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>

      <el-row class="table-btns">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-edit"
          @click="interBankTransfer"
          >{{ $t("addInterBankTransfer") }}</el-button
        >
      </el-row>
    </div>

    <!-- Data Table -->
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`
      }"
    >
      <el-table
        :data="table.records"
        v-loading="btnStatus.isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="index"
          prop="id"
          align="center"
          :label="$t('ID')"
          fixed="left"
          width="60"
        >
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>

        <el-table-column
          prop="fromBankName"
          :label="$t('fromBank')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.fromBankName }} ({{ scope.row.fromBankId }})
          </template>
        </el-table-column>
        <el-table-column
          prop="toBankName"
          :label="$t('toBank')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.toBankName }} ({{ scope.row.toBankId }})
          </template>
        </el-table-column>

        <el-table-column
          prop="referenceNumber"
          :label="$t('referenceNumber')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.referenceNumber }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" :label="$t('amount')" min-width="160">
          <template slot-scope="scope">
            <span class="franc">₣</span> {{ scope.row.amount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="fees"
          :label="$t('transferFees')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span class="franc">₣</span> {{ scope.row.fees.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('Status')" min-width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-warning">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="transfeDate"
          :label="$t('transferDate')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ $manba(scope.row.transfeDate).format("ymdhms") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          :label="$t('createdAt')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ $manba(scope.row.createdAt).format("ymdhms") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="creatorName"
          :label="$t('creatorName')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.creatorName }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('remark')" min-width="200">
          <template slot-scope="scope">
            {{ scope.row.applyRemark }}
          </template>
        </el-table-column>

        <el-table-column
          prop="verifiedAt"
          :label="$t('verifiedAt')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifiedAt">{{
              $manba(scope.row.verifiedAt).format("ymdhms")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifierName"
          :label="$t('verifierName')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifierName">{{
              scope.row.verifierName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="transferCode"
          :label="$t('transferCode')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.transferCode }}
          </template>
        </el-table-column>
        <el-table-column
          prop="verificationRemark"
          :label="$t('verificationRemark')"
          min-width="200"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verificationRemark">{{
              scope.row.verifyRemark
            }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('extend')" fixed="right" width="210">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 0"
              size="mini"
              @click="showDrawer(scope.row)"
              type="primary"
              >{{ $t("check") }}</el-button
            >
            <el-button v-else size="mini" disabled>{{ $t("check") }}</el-button>
            <el-button
              size="mini"
              v-if="scope.row.status == 0"
              @click="editBankTransfer(scope.row)"
              type="primary"
              >{{ $t("edit") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--End Data Table-->
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="table.total"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="
        $t(
          applyForm.type === 0
            ? 'addInterBankTransfer'
            : 'editInterBankTransfer'
        )
      "
      :visible.sync="isAddApply"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="applyForm" :rules="rules" ref="applyForm">
        <el-divider content-position="left">{{ $t("applyInfo") }}</el-divider>

        <el-form-item :label="$t('fromBank')" prop="fromBankId">
          <el-select
            size="medium"
            v-model="applyForm.fromBankId"
            filterable
            :placeholder="$t('selectBank')"
            style="width:100%;"
          >
            <el-option
              v-for="item in bankList"
              :key="item.id"
              :label="item.bankName"
              :value="item.id"
              v-show="item.status === 0"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('toBank')" prop="toBankId">
          <el-select
            size="medium"
            v-model="applyForm.toBankId"
            filterable
            :placeholder="$t('selectBank')"
            style="width:100%;"
          >
            <el-option
              v-for="item in bankList"
              :key="item.id"
              :label="item.bankName"
              :value="item.id"
              v-show="item.status === 0"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('referenceNumber')" prop="referenceNumber">
          <el-input v-model="applyForm.referenceNumber"></el-input>
        </el-form-item>
        <el-form-item :label="$t('transfeDate')" prop="transfeTime">
          <el-date-picker
            v-model="applyForm.transfeTime"
            type="datetime"
            :time-arrow-control="true"
            :format="'yyyy-MM-dd HH:mm:ss'"
            :placeholder="$t('selectDateAndTime')"
            style="width:100%"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('transferAmount')" prop="amount">
          <el-input
            size="medium"
            v-model="applyForm.amount"
            @input="applyForm.amount = applyForm.amount.formatMoney(0, ' ')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('transferFees')" prop="fees">
          <el-input
            size="medium"
            v-model="applyForm.fees"
            @input="applyForm.fees = applyForm.fees.formatMoney(0, ' ')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('applayRemark')" prop="remark">
          <el-input
            type="textarea"
            size="medium"
            v-model="applyForm.remark"
          ></el-input>
        </el-form-item>
        <div class="bottom-button">
          <el-button
            v-if="applyForm.id"
            size="medium"
            type="primary"
            @click="updateSubmit('applyForm')"
            :loading="btnEdit.isLoading"
            >{{ $t("edit") }}</el-button
          >
          <el-button
            v-else
            size="medium"
            type="primary"
            :loading="btnSend.isLoading"
            @click="onSubmitAdd('applyForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>
    <el-drawer
      :title="$t('checkInterBankTransfer')"
      :visible.sync="checkDrawer"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="checkForm" :rules="rules2" ref="checkForm">
        <el-divider content-position="left">{{ $t("applyInfo") }}</el-divider>
        <el-form-item :label="$t('amount')">
          <el-input size="medium" v-model="rowData.amount" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('fromBank')" prop="fromBankName">
          <el-input
            size="medium"
            v-model="rowData.fromBankName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('toBank')" prop="toBankName">
          <el-input
            size="medium"
            v-model="rowData.toBankName"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('referenceNumber')" prop="referenceNumber">
          <el-input size="medium" v-model="checkForm.id" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('transfeDate')" prop="transfeDate">
          <el-input
            size="medium"
            :value="$manba(rowData.transfeDate).format('ymdhms')"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('transferFees')" prop="fees">
          <el-input size="medium" v-model="rowData.fees" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('remark')" prop="remark">
          <el-input
            type="textarea"
            size="medium"
            v-model="rowData.remark"
            disabled
          ></el-input>
        </el-form-item>
        <el-divider content-position="left">{{ $t("checkInfo") }}</el-divider>
        <el-form-item :label="$t('checkStatus')" prop="status">
          <el-radio v-model="checkForm.status" :label="1" border>{{
            $t("getApproved")
          }}</el-radio>
          <el-radio v-model="checkForm.status" :label="2" border>{{
            $t("notApproved")
          }}</el-radio>
        </el-form-item>
        <el-form-item
          :label="$t('verificationRemark')"
          prop="verificationRemark"
        >
          <el-input
            type="textarea"
            size="medium"
            v-model="checkForm.verificationRemark"
          ></el-input>
        </el-form-item>
        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="onSubmitCheckResult('checkForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import bank from "@/api/bank";
import bankTransfer from "@/api/bankTransfer";
import manba from "@/assets/uilt/manbaDate";

export default {
  name: "interBankTransfer",
  data() {
    return {
      //table高度，动态设置
      queryTableHeight: String,
      queryForm: {},

      //显示加载中
      isLoading: false,
      btnStatus: { isLoading: false },
      btnSend: { isLoading: false },
      btnEdit: { isLoading: false },

      table: {
        records: [{}]
      },
      bankList: [],
      pageSize: 20,
      currentPage: 1,
      checkDrawer: false,
      checkForm: {},

      applyTitle: "interBankTransfer",
      applyForm: {
        type: 0
      },

      isAddApply: false,
      rowData: {},

      //禁用今天之后的日期选项
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: time => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        }
      }
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    rules() {
      return {
        fromBankId: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ],
        toBankId: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ],
        referenceNumber: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ],
        amount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ],
        fees: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ],
        transfeTime: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
      };
    },
    rules2() {
      return {
        status: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
      };
    }
  },

  watch: {
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = this.queryForm.date[0];
        this.queryForm.endTime = this.queryForm.date[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    }
  },

  methods: {
    getList() {
      let _this = this;
      //_this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));
      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      } else {
        params.startTime = undefined;
        params.endTime = undefined;
      }
      delete params.date;

      bankTransfer.getInterBankTransferPage({
        param: {
          current: _this.table.currentPage,
          size: _this.table.pageSize,
          ...params
        },
        success: res => {
          _this.table = res.data || {};
          //_this.isLoading = false;
        }
      });
    },

    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
        this.pickerBeginDateBefore = {
          disabledDate: time => {
            let three = 3 * 30 * 24 * 3600 * 1000;
            if (this.minDate) {
              return (
                time.getTime() > Date.now() ||
                time > new Date(this.minDate.getTime() + three) ||
                time < new Date(this.minDate.getTime() - three)
              );
            }
            return time.getTime() > Date.now();
          }
        };
      }
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    interBankTransfer() {
      this.applyForm = {};
      this.isAddApply = true;
    },
    /**提交充值申请 */
    onSubmitAdd(refName) {
      let _this = this;
      _this.isLoading = true;
      this.$refs[refName].validate(valid => {
        if (!valid) return false;
        _this[refName].transfeTime = manba(_this[refName].transfeTime).format(
          "ymdhms"
        );
        bankTransfer.addInterBankTransfer({
          param: _this[refName],
          success: res => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.isAddApply = false;
              _this.applyForm = {};
              _this.getList();
            } else _this.$message.warning(_this.$t(res.msg));
          }
        });

        _this.isLoading = false;
      });

      _this.isLoading = false;
    },
    /**打开审核弹框 */
    showDrawer(row) {
      this.rowData = row;
      this.checkDrawer = true;
      this.checkForm = {
        id: row.id,
        referenceNumber: row.referenceNumber
      };
    },
    editBankTransfer(row) {
      this.isAddApply = true;
      this.applyForm = {
        id: row.id,
        ...row,
        transfeTime: row.transferDate.toString(),
        type: 1
      };
    },
    /**updateSubmit */
    updateSubmit(refName) {
      let _this = this;
      _this.isLoading = true;
      this.$refs[refName].validate(valid => {
        if (!valid) return false;
        _this[refName].transfeTime = manba(_this[refName].transfeTime).format(
          "ymdhms"
        );
        console.log("ID : ", _this[refName].id);
        bankTransfer.updateInterBankTransfer({
          param: _this[refName],
          success: res => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.isAddApply = false;
              _this.applyForm = {};
              _this.getList();
            } else _this.$message.warning(_this.$t(res.msg));
          }
        });
      });
    },
    onSubmitCheckResult(refName) {
      let _this = this;
      _this.isLoading = true;
      this.$refs[refName].validate(valid => {
        if (!valid) return false;
        bankTransfer.checkInterBankTransfer({
          param: _this[refName],

          success: res => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.checkDrawer = false;
              _this.getList();
            } else _this.$message.warning(_this.$t(res.msg));
          }
        });
        _this.checkForm = {};

        _this.isLoading = false;
      });
      _this.checkForm = {};

      _this.isLoading = false;
    },
    getBankList() {
      let _this = this;
      bank.getAllAccounts({
        success: res => {
          if (res.code != 200) return;
          _this.bankList = res.data;
        }
      });
    }
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";

    this.getList();
    this.getBankList();
  }
};
</script>

<style lang="less" scoped></style>
